import { render } from "./FormTag.vue?vue&type=template&id=dc15ab5a&scoped=true"
import script from "./FormTag.vue?vue&type=script&lang=js"
export * from "./FormTag.vue?vue&type=script&lang=js"

import "./FormTag.vue?vue&type=style&index=0&id=dc15ab5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc15ab5a"],['__file',"src/components/h5/layout/FormTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc15ab5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc15ab5a', __exports__)) {
    api.reload('dc15ab5a', __exports__)
  }
  
  module.hot.accept("./FormTag.vue?vue&type=template&id=dc15ab5a&scoped=true", () => {
    api.rerender('dc15ab5a', render)
  })

}


export default __exports__